@if (!isViewMode()) {
  <div class="wizard-stepper" data-testid="wizard-stepper">
    <!-- Progress bar segments -->
    <div class="progress-bar">
      @for (step of steps(); track step.index; let i = $index) {
        <div
          class="progress-segment"
          [attr.data-testid]="'wizard-stepper-segment-' + i"
          [class.active]="i <= currentStep()"
          [class.clickable]="canClickStep(step)"
          (click)="onStepClick(step)"
        ></div>
      }
    </div>

    <!-- Step labels -->
    <div class="step-labels">
      @for (step of steps(); track step.index) {
        <span
          class="step-label"
          [attr.data-testid]="'wizard-stepper-label-' + step.index"
          [class.active]="step.index === currentStep()"
          [class.completed]="step.index < currentStep()"
          [class.clickable]="canClickStep(step)"
          (click)="onStepClick(step)"
        >
          {{ step.label | transloco }}
        </span>
      }
    </div>
  </div>
}
